import { create } from 'zustand'

const isClientManagementPath = (path: string | null) => {
  if (path == null) {
    return false
  }

  return [
    '/ClientManagement',
    '/LicensedEstablishment/',
    '/LicensedEstablishments/',
    '/Organizations/',
    '/Organization/',
    '/CorporateAccounts/',
  ].some((prefix) => path.startsWith(prefix))
}

export interface SnackbarState {
  setOpen: (key: string) => void
  setActiveTab: (path: string) => void
  activeTab: string | null
  'Client Management': boolean
  Contests: boolean
  Rewards: boolean
  Communications: boolean
}

export const useSideNavCollapseStore = create<SnackbarState>((set, get) => ({
  setOpen: (key) => {
    const state = get()
    const isActiveTab = state.activeTab?.startsWith(key)

    // Close all drawers first
    const newState = {
      'Client Management': isClientManagementPath(state.activeTab),
      Contests: state.activeTab?.startsWith('/Contests') ?? false,
      Rewards: state.activeTab?.startsWith('/Rewards') ?? false,
      Communications: state.activeTab?.startsWith('/Communications') ?? false,
      [key]:
        !state[
          key as keyof Omit<
            SnackbarState,
            'setOpen' | 'setActiveTab' | 'activeTab'
          >
        ] || isActiveTab,
    }

    set(newState)
  },
  setActiveTab: (path) => {
    // Determine which drawer should remain open based on the active tab
    const newState = {
      activeTab: path,
      'Client Management': isClientManagementPath(path),
      Contests: path.startsWith('/Contests'),
      Rewards: path.startsWith('/Rewards'),
      Communications: path.startsWith('/Communications'),
    }

    set(newState)
  },
  activeTab: null,
  'Client Management': false,
  Contests: false,
  Rewards: false,
  Communications: false,
}))
